require './view'
require './slider'
require './create'
require './post-processing'
